import { render, staticRenderFns } from "./guide.vue?vue&type=template&id=0bfa50ee&scoped=true&"
import script from "./guide.vue?vue&type=script&lang=js&"
export * from "./guide.vue?vue&type=script&lang=js&"
import style0 from "./guide.vue?vue&type=style&index=0&id=0bfa50ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfa50ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bfa50ee')) {
      api.createRecord('0bfa50ee', component.options)
    } else {
      api.reload('0bfa50ee', component.options)
    }
    module.hot.accept("./guide.vue?vue&type=template&id=0bfa50ee&scoped=true&", function () {
      api.rerender('0bfa50ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/components/pageLayout/guide.vue"
export default component.exports